// Runtime enum values that mirror backend choice fields, statically checked
// against the generated OpenAPI types so they can't silently drift.
//
// The frontend is .jsx (types are erased at runtime), so these must stay
// real runtime objects — but `satisfies` makes `tsc` (see `npm run
// typecheck`) fail if any value stops being a valid schema enum member
// (e.g. the backend renames or removes one). Adding a *new* backend value
// is not flagged here — `satisfies` checks validity, not exhaustiveness —
// it just won't appear in the UI until added below.
//
// Regenerate the source of truth with `make types`.
import type { components } from "../types/api";

type TaskStatus = components["schemas"]["TaskStatusEnum"];
type SnippetType = components["schemas"]["SnippetTypeEnum"];

export const TASK_STATUS = {
  TODO: "TODO",
  IN_PROGRESS: "IN_PROGRESS",
  BLOCKED: "BLOCKED",
  DONE: "DONE",
  CANCELED: "CANCELED",
} as const satisfies Record<string, TaskStatus>;

export const SNIPPET_TYPE = {
  PLAIN: "plain",
  MARKDOWN: "markdown",
  CODE: "code",
} as const satisfies Record<string, SnippetType>;
